import React from "react";

const FLAGS = ["🇨🇦", "🇬🇧", "🇦🇺", "🇩🇪", "🇦🇪", "🇸🇬", "🇺🇸", "🇳🇿", "🇮🇪", "🇳🇱"];
const NAMES = ["Canada", "UK", "Australia", "Germany", "UAE", "Singapore", "USA", "N. Zealand", "Ireland", "Netherlands"];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="border-y border-[var(--card-border)] bg-app-alt py-8">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-[11px] uppercase tracking-[0.3em] text-app-muted mb-6">
          Approved partners across 46 countries
        </p>
        <div className="flex flex-wrap justify-center gap-x-10 gap-y-4">
          {FLAGS.map((f, i) => (
            <div key={NAMES[i]} className="flex items-center gap-2 flag-mono">
              <span className="text-2xl">{f}</span>
              <span className="text-xs text-app-muted uppercase tracking-widest">{NAMES[i]}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
